import React from 'react';
import PropTypes from 'prop-types';

export default class Logout extends React.Component {

  componentWillMount() {
    this.props.userLogout();
  }

  render() {
    return null;
  }
}

Logout.defaultProps = {
  userLogout: () => {},
};

Logout.propTypes = {
  userLogout: PropTypes.func,
};
